module.exports = Em.View.extend({
    templateName: 'daybook/edit-transaction-line',

    classNames: ['daybook-edit-transaction-line', 'flex-1', 'horizontal-field-group', 'merged']
})
